<template>
  <div>
    <DxDataGrid
        id="gridContainer"
        :allow-column-reordering="true"
        :column-auto-width="true"
        :column-hiding-enabled="true"
        :data-source="ds"
        :row-alternation-enabled="true"
        :show-borders="true"
        @exporting="onExporting"
        @initialized="gridInitialized"
    >
      <DxExport :allow-export-selected-data="true" :enabled="true"/>
      <!--      rebuild-->
      <!--      <DxSelection-->
      <!--        :select-all-mode="allMode"-->
      <!--        :show-check-boxes-mode="checkBoxesMode"-->
      <!--        mode="multiple"-->
      <!--      />-->
      <DxScrolling row-rendering-mode="virtual"/>
      <DxPaging :page-size="40"/>
      <DxScrolling mode="infinite"/>
      <DxGroupPanel :visible="true"/>
      <DxGrouping :auto-expand-all="true"/>
      <DxRemoteOperations :group-paging="true"/>
      <DxFilterRow :visible="true"/>
      <DxFilterPanel :visible="false"/>
      <DxHeaderFilter :visible="true"/>
      <DxScrolling mode="virtual"/>
      <DxEditing :allow-updating="true" mode="popup"/>

      <DxColumn
          :allow-editing="false"
          caption="Mã đơn"
          data-field="Id"
          width="120"
      />
      <DxColumn
          :allow-editing="false"
          caption="Số đặt mua"
          data-field="Msisdns"
          width="150"
      />
      <DxColumn :allow-editing="false" caption="Họ tên" data-field="FullName"/>
      <DxColumn
          :allow-editing="false"
          caption="Số liên hệ"
          data-field="ContactPhone"
          width="110"
      />
      <!--      <DxColumn-->
      <!--        data-field="TotalPrice"-->
      <!--        caption="Tổng tiền"-->
      <!--        data-type="number"-->
      <!--        format="currency"-->
      <!--        width="100"-->
      <!--      />-->
      <DxColumn
          :allow-editing="false"
          caption="Ngày mua"
          data-field="CreateDate"
          format="dd/MM/yyyy HH:mm:ss"
      />
      <!--    <DxColumn data-field="CreateFrom" caption="Nguồn" width="100"/>-->
      <!--      <DxColumn-->
      <!--        data-field="PaymentChannel"-->
      <!--        caption="Kênh thanh toán"-->
      <!--        width="120"-->
      <!--      />-->
      <DxColumn
          :allow-editing="false"
          :set-cell-value="setStateValue"
          caption="Trạng thái"
          data-field="Status"
      >
        <DxLookup
            :data-source="lookupDataSource"
            display-expr="text"
            value-expr="id"
        />
      </DxColumn>
      <DxColumn caption="Địa chỉ" column-with="auto" data-field="Addr"/>
      <DxColumn
          :allow-editing="false"
          caption="Mã đơn vận"
          data-field="GHTK_Id"
      />

      <!--      <DxColumn data-field="WardName" caption="Addr" :allow-editing="false" />-->
      <!--      <DxColumn-->
      <!--        data-field="DistrictName"-->
      <!--        caption="Addr"-->
      <!--        :allow-editing="false"-->
      <!--      />-->
      <!--      <DxColumn data-field="CityName" caption="Addr" :allow-editing="false" />-->
      <DxColumn type="buttons" width="100">
        <DxGridButton
            :on-click="getHistoryOrderVTP"
            hint="Lịch sử tạo đơn VTP"
            icon="fa-solid fa-scroll"
        />
        <DxGridButton
            :on-click="changeAdr"
            hint="Sửa thông tin đơn hàng"
            icon="fa-solid fa-pen"
            name="edit"
        />
        <DxGridButton
            :on-click="confirmCreateTicket"
            hint="Tạo đơn VTP"
            icon="fa-solid fa-ticket-simple"
            name="edit"
        />
      </DxColumn>
      <DxMasterDetail :enabled="true" template="masterDetailTemplate"/>
      <template #masterDetailTemplate="{ data: item }">
        <OrderDetailView :template-data="item"/>
      </template>
    </DxDataGrid>
    <b-modal
        id="modal-order-log"
        ok-only
        ok-title="Đóng"
        size="lg"
        title="Lịch sử tạo đơn VTP"
    >
      <table class="table table-bordered">
        <tr>
          <th>Thông tin</th>
          <th>Lỗi</th>
          <th>Tin nhắn</th>
          <th>Mã</th>
        </tr>
        <tr v-for="log in orderLog">
          <td>
            <div v-if="log.data">
              <p v-for="(item, key) in log.data">{{ key }} : {{ item }}</p>
            </div>
            <div v-else></div>
          </td>
          <td>{{ log.error ? "Có" : "Không" }}</td>
          <td>{{ log.message }}</td>
          <td>{{ log.status }}</td>
        </tr>
      </table>
    </b-modal>
    <b-modal
        id="modal-change-adr"
        ok-only
        ok-title="Cập nhật"
        size="lg"
        title="Sửa địa chỉ"
        @ok="handleChangeAddr"
    >
      <div>
        <div>
          <b>Thành phố:</b>
          <DxTextBox v-model="addrInput.CityName" :disabled="true"></DxTextBox>
        </div>
        <div>
          <b>Quận/ Huyện:</b>
          <DxTextBox
              v-model="addrInput.DistrictName"
              :disabled="true"
          ></DxTextBox>
        </div>
        <div>
          <b>Xã:</b>
          <DxTextBox v-model="addrInput.WardName" :disabled="true"></DxTextBox>
        </div>
        <div>
          <b>Địa chỉ:</b>
          <DxTextBox v-model="addrInput.addr"></DxTextBox>
        </div>
      </div>
    </b-modal>
    <b-modal
        id="modal-confirm-create-ticket"
        ok-only
        ok-title="Tạo"
        size="md"
        title="Tạo vận đơn"
        @ok="createTicket"
    >
      <div class="font-medium-2">
        Bạn có chắc muốn tạo vận đơn cho đơn <b>{{ addrInput.id }}</b> không?
      </div>
    </b-modal>
  </div>
</template>
<script>
import DxDataGrid, {
  DxButton as DxGridButton,
  DxColumn,
  DxEditing,
  DxExport,
  DxFilterPanel,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxHeaderFilter,
  DxLookup,
  DxMasterDetail,
  DxPager,
  DxPaging,
  DxRemoteOperations,
  DxScrolling,
  DxSelection
} from "devextreme-vue/data-grid";
import 'devextreme/data/odata/store';
import {Workbook} from "exceljs";
import {saveAs} from "file-saver-es";
import {exportDataGrid} from "devextreme/excel_exporter";
import CustomStore from "devextreme/data/custom_store";
import viMessages from "devextreme/localization/messages/vi.json";
import {loadMessages, locale} from "devextreme/localization";
import DataSource from "devextreme/data/data_source";
import OrderDetailView from "./OrderDetailView.vue";
import {DxTextBox} from "devextreme-vue/text-box";
import {$ctx} from "@themeConfig";
import config from "devextreme/core/config";
import useJwt from "@/auth/jwt/useJwt";
import B2CSalesOrderDetails from "@/views/report/B2CSalesOrderDetails.vue";
import {BCol, BFormGroup, BFormInput, BModal, BRow} from "bootstrap-vue";
import {ValidationProvider} from "vee-validate";

config({
  defaultCurrency: "VND"
});
let ds = new DataSource({
  store: {
    type: "odata",
    version: 4,
    url: $ctx.API_URL + "odata.svc/Orders",
    key: "Id",
    beforeSend: e => {
      e.headers = {
        apiKey: localStorage.getItem("accessToken")
      };
    }
  },
  sort: [{selector: "CreateDate", desc: true}]
});
const lookupDataSource = {
  store: new CustomStore({
    key: "id",
    loadMode: "raw",
    load: () => {
      return useJwt
          .get("order/meta")
          .then(response => {
            return response.data.result.statusLockup;
          })
          .catch(error => {
            return [];
          });
    }
  })
};

export default {
  components: {
    DxTextBox,
    DxEditing,
    BFormInput,
    BModal,
    ValidationProvider,
    BRow,
    BCol,
    BFormGroup,
    B2CSalesOrderDetails,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPager,
    DxPaging,
    DxGroupPanel,
    DxGrouping,
    DxRemoteOperations,
    DxFilterRow,
    DxFilterPanel,
    DxHeaderFilter,
    DxLookup,
    DxMasterDetail,
    DxGridButton,
    OrderDetailView,
    DxExport,
    DxSelection,
    Workbook,
    saveAs,
    exportDataGrid
    // ExTable
  },
  created() {
    loadMessages(viMessages);
    locale("vi-VN");
  },
  data() {
    return {
      ds,
      dataSource: {
        // filter: [
        //   [ "StoreId", "=", 1 ]
        // ]
      },
      filter: [[]],
      dataGridInstance: null,
      statusList: [],
      lookupDataSource,
      orderLog: [],
      addrInput: {
        id: "",
        addr: "",
        CityName: "",
        DistrictName: "",
        WardName: ""
      }
    };
  },
  async mounted() {
    await this.getMeta();
    ds.loadOptions().filter = this.filter;
    ds.load().then(
        data => {
          // console.log(data);
        },
        error => {
          /* Handle the "error" here */
        }
    );
  },
  methods: {
    getHistoryOrderVTP(e) {
      this.orderLog = [];
      this.loading(true);
      useJwt
          .get("ship/get-vtp-create-order-log/" + e.row.data.Id)
          // .get("ship/get-vtp-create-order-log/620868524961")
          .then(response => {
            this.loading(false);
            // console.log(response.data);
            response.data.result.forEach(e => {
              //remove \ in string
              e.replace(/\\/g, "");
              this.orderLog.push(JSON.parse(e));
            });
            this.$bvModal.show("modal-order-log");
            // console.log(this.orderLog);
          })
          .catch(error => {
            this.loading(false);
            console.log(error.response.data);
            this.$toast.warning("Có lỗi xảy ra vui lòng thử lại ", {
              icon: true,
              closeButton: "button"
            });
          });
    },
    setStateValue(rowData, value) {
      rowData.Status = null;
      this.defaultSetCellValue(rowData, value);
    },
    viewDetail(e) {
      if (e.rowType === "data") {
        // e.component.editRow(e.rowIndex);
        console.log("Hello");
      }
    },
    gridInitialized: function (e) {
      this.dataGridInstance = e.component;
      this.dataGridInstance.option({
        showRowLines: true,
        columns: [{dataField: "Id", caption: "Mã đơn", width: 120}]
      });
      this.dataGridInstance.option("columns", [
        {dataField: "Id", caption: "Mã đơn", width: 120}
      ]);
    },
    onExporting: e => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Data");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then(buffer => {
          saveAs(
              new Blob([buffer], {type: "application/octet-stream"}),
              "DataExport.xlsx"
          );
        });
      });
      e.cancel = true;
    },
    refresh: function () {
      this.dataGridInstance.refresh();
    },
    async getMeta() {
      await useJwt.get("order/meta").then(response => {
        this.filter = response.data.result.filter;
      });
    },
    toggleModalChangeAdr(isShow) {
      if (isShow) {
        this.$bvModal.show("modal-change-adr");
      } else {
        this.$bvModal.hide("modal-change-adr");
      }
    },
    toggleModalConfirmCreateTicket(isShow) {
      if (isShow) {
        this.$bvModal.show("modal-confirm-create-ticket");
      } else {
        this.$bvModal.hide("modal-confirm-create-ticket");
      }
    },
    confirmCreateTicket(data) {
      this.addrInput.id = data.row.data.Id;
      this.toggleModalConfirmCreateTicket(true);
    },
    createTicket() {
      this.loading(true);
      useJwt
          .get("ship/create-order/VTP/" + this.addrInput.id)
          .then(res => {
            this.loading(false);
            this.toggleModalConfirmCreateTicket(false);
            this.refresh();
            this.$toast.success("Tạo đơn VTP thành công", {
              icon: true,
              closeButton: "button"
            });
          })
          .catch(err => {
            this.loading(false);
            this.toggleModalConfirmCreateTicket(false);
            this.$toast.error("Có lỗi xảy ra vui lòng thử lại ", {
              icon: true,
              closeButton: "button"
            });
          });
    },
    changeAdr(data) {
      this.addrInput.addr = data.row.data.Addr;
      this.addrInput.id = data.row.data.Id;
      this.addrInput.CityName = data.row.data.CityName;
      this.addrInput.DistrictName = data.row.data.DistrictName;
      this.addrInput.WardName = data.row.data.WardName;
      this.toggleModalChangeAdr(true);
    },
    handleChangeAddr() {
      useJwt
          .post("ship/change-receiver-address", {
            orderId: this.addrInput.id,
            address: this.addrInput.addr
          })
          .then(res => {
            this.$toast.success("Cập nhật thành công", {
              icon: true,
              closeButton: "button"
            });
            this.refresh();
            this.toggleModalChangeAdr(false);
          })
          .catch(err => {
            this.$toast.error("Có lỗi xảy ra vui lòng thử lại ", {
              icon: true,
              closeButton: "button"
            });
            this.toggleModalChangeAdr(false);
          });
    }
  }
};
</script>
<style>
#gridContainer {
  height: 80vh;
}
</style>
